import {
  makeReportingDuck,
  ReportingDuckActions,
} from 'ducks/make-reporting-duck';
import { getPaginated, getApi } from 'util/backendapi/fetch';

export const checksheetInstanceListDuck = makeReportingDuck(
  'checksheetTemplate',
  (filters) => getPaginated('/reports/checksheet-instances/', filters),
  () => getApi('/reports/checksheet-instances/info/')
);

export type ChecksheetInstanceListAction = ReportingDuckActions<
  typeof checksheetInstanceListDuck
>;
